import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/tradepassport-empty-thumbnail.png'


const _withScopeId = n => (_pushScopeId("data-v-6fda5b66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "tradepassport_certificate__dashboard tw-w-full tw-max-w-[1300px] md:!tw-pb-[4rem] md:!tw-box-border"
}
const _hoisted_3 = { class: "tw-w-full tw-rounded-lg tw-bg-[#F8FBFD] tw-border-solid tw-border-[1px] tw-border-[#DFDFDF] tw-p-4 tw-box-border tw-flex tw-flex-col tw-gap-3" }
const _hoisted_4 = { class: "tw-flex tw-items-center tw-justify-between tw-pb-3 tw-box-border tw-border-b-dashed-custom" }
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-gap-2 tw-justify-start" }
const _hoisted_6 = { class: "tw-flex tw-flex-col tw-w-full" }
const _hoisted_7 = { class: "tw-flex tw-items-start tw-gap-3 tw-w-full md:!tw-gap-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-min-w-[68px] tw-w-[68px] tw-h-[68px] tw-rounded-[4.85px] tw-bg-[rgba(12,15,74,0.04)] tw-border-solid tw-border-[#DFDFDF] tw-border-[1px] tw-overflow-hidden md:!tw-min-w-[55px] md:!tw-w-[55px] md:!tw-h-[55px]" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "tw-w-full tw-h-full tw-object-cover"
  })
], -1))
const _hoisted_9 = { class: "tw-w-full tw-flex tw-items-start tw-justify-between tw-gap-1" }
const _hoisted_10 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-[.1rem] tw-items-start" }
const _hoisted_11 = { class: "tw-flex tw-items-start tw-gap-2" }
const _hoisted_12 = {
  key: 0,
  class: "tw-flex tw-gap-1 tw-flex-col tw-items-start"
}
const _hoisted_13 = { class: "tw-flex tw-items-center" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 0,
  class: "tw-flex tw-items-center tw-gap-2 md:!tw-gap-1"
}
const _hoisted_16 = {
  key: 2,
  class: "empty__content !tw-pb-12 !tw-box-border !tw-h-auto tw-w-full"
}
const _hoisted_17 = { class: "empty__banner tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4" }
const _hoisted_18 = { class: "empty__banner__img md:!tw-w-[50%]" }
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 0,
  class: "empty__banner__content"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "You don't have any certification yet!", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " You haven't added any certifications yet. Add them to build trust and showcase your qualifications to property owners. ", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = {
  key: 1,
  class: "empty__banner__content"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Don't have any certification yet!", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "haven't added any certifications to this profile yet.", -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { class: "empty__banner__footer tw-w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Text = _resolveComponent("Text")!
  const _component_PendingVerifyNotice = _resolveComponent("PendingVerifyNotice")!
  const _component_TradeWelcomeBoard = _resolveComponent("TradeWelcomeBoard")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PendingChip = _resolveComponent("PendingChip")!
  const _component_AcceptChip = _resolveComponent("AcceptChip")!
  const _component_RejectChip = _resolveComponent("RejectChip")!
  const _component_UserProfileLogo = _resolveComponent("UserProfileLogo")!
  const _component_BlueCircularPencilIcon = _resolveComponent("BlueCircularPencilIcon")!
  const _component_GrayCircularTrashIcon = _resolveComponent("GrayCircularTrashIcon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_AddCertificateModal = _resolveComponent("AddCertificateModal")!
  const _component_CertificateEditModal = _resolveComponent("CertificateEditModal")!
  const _component_ConfirmDeleteModal = _resolveComponent("ConfirmDeleteModal")!
  const _component_IknowaCoursePreviewModal = _resolveComponent("IknowaCoursePreviewModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Loader, {
            show: $setup.isLoading,
            class: "tw-z-10"
          }, null, 8, ["show"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onRouteToTradePassport && $setup.onRouteToTradePassport(...args))),
      class: "tw-flex tw-items-center tw-gap-[.1rem] tw-cursor-pointer tw-pb-4 tw-w-full"
    }, [
      _createVNode(_component_v_icon, { icon: "mdi-chevron-left" }),
      _createVNode(_component_Text, {
        variant: "p",
        textWeight: "600"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Back")
        ]),
        _: 1
      })
    ]),
    (!$setup.isLoading && $setup.userCertificates?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          ($setup.isShowPendingBoard)
            ? (_openBlock(), _createBlock(_component_PendingVerifyNotice, {
                key: 0,
                content: "New certificates are being verified. Use old ones."
              }))
            : _createCommentVNode("", true),
          ($setup.hasVerifiedCertificate)
            ? (_openBlock(), _createBlock(_component_TradeWelcomeBoard, {
                key: 1,
                class: "tw-mb-4 tw-border-solid tw-border-[1px] tw-border-[#DFDFDF] !tw-bg-[#F8FBFD]",
                title: "Learn more about iknowa by exploring the Courses",
                actionTitle: "Explore iknowa Courses",
                onOnClickAction: $setup.onClickOpenCoursePreviewModal
              }, null, 8, ["onOnClickAction"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Text, {
                  variant: "h6",
                  class: "rmd:!tw-text-[22px]",
                  lineHeight: "18px",
                  textAlign: "left"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.isUserProprtyOwner ? "Certifications" : "Your Certifications"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Text, {
                  variant: "p",
                  textWeight: "600",
                  textColor: "rgba(12, 15, 74, 0.8)",
                  lineHeight: "18px",
                  textAlign: "left",
                  class: "md:!tw-hidden"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.userCertificates?.length) + " Results", 1)
                  ]),
                  _: 1
                })
              ]),
              (!$setup.isUserProprtyOwner)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    variant: "secondary",
                    label: "+Add Certifications",
                    class: "!tw-w-auto md:!tw-min-h-[unset] md:!tw-px-2",
                    onClick: $setup.onClickAddNewCertification
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userCertificates, (certificate, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["tw-w-full tw-flex tw-flex-col tw-gap-4 tw-py-4 tw-box-border", {
            'tw-border-b-dashed-custom': index !== $setup.userCertificates.length - 1,
            '!tw-pt-0': index === 0,
          }])
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_Text, {
                            variant: "h6",
                            textAlign: "left",
                            lineHeight: "18px",
                            class: "tw-w-[70%] md:!tw-text-[.8rem]"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(certificate.metadata.name
                        ? certificate.metadata.name
                        : certificate.certificate.name), 1)
                            ]),
                            _: 2
                          }, 1024),
                          (
                      certificate?.userVerificationStatus ===
                      $setup.UserVerificationStatusEnum.PENDING_VERIFICATION
                    )
                            ? (_openBlock(), _createBlock(_component_PendingChip, {
                                key: 0,
                                class: "tw-w-[auto]",
                                label: "Pending Verification"
                              }))
                            : _createCommentVNode("", true),
                          (
                      certificate?.userVerificationStatus ===
                        $setup.UserVerificationStatusEnum.VERIFIED &&
                      !$setup.isUserProprtyOwner
                    )
                            ? (_openBlock(), _createBlock(_component_AcceptChip, {
                                key: 1,
                                class: "tw-w-[auto]",
                                label: "Accepted"
                              }))
                            : _createCommentVNode("", true),
                          (
                      certificate?.userVerificationStatus ===
                        $setup.UserVerificationStatusEnum.VERIFIED &&
                      $setup.isUserProprtyOwner
                    )
                            ? (_openBlock(), _createBlock(_component_AcceptChip, {
                                key: 2,
                                class: "tw-w-[auto]",
                                label: "Verified"
                              }))
                            : _createCommentVNode("", true),
                          (
                      certificate?.userVerificationStatus ===
                      $setup.UserVerificationStatusEnum.REJECTED
                    )
                            ? (_openBlock(), _createBlock(_component_RejectChip, {
                                key: 3,
                                class: "tw-w-[auto]",
                                label: "Rejected"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_Text, {
                          variant: "p",
                          textColor: "rgba(12, 15, 74, 0.8)",
                          lineHeight: "18px",
                          class: "md:!tw-text-[.7rem]",
                          textAlign: "left"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Membership No: " + _toDisplayString(certificate?.metadata?.registrationNumber), 1)
                          ]),
                          _: 2
                        }, 1024),
                        (certificate?.assignedUsers)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createVNode(_component_Text, {
                                variant: "p",
                                textColor: "rgba(12, 15, 74, 0.8)",
                                lineHeight: "18px",
                                class: "md:!tw-text-[.7rem]",
                                textAlign: "left"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Member(s): ")
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_13, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(certificate.assignedUsers, (data, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: _normalizeClass(["tw-min-w-[26px] tw-w-[26px] tw-h-[26px] tw-overflow-hidden tw-rounded-[4px] tw-border-solid tw-border-[#FFFFFF] tw-border-[1px]", { 'tw-ml-[-.5rem]': index !== 0 }])
                                  }, [
                                    (data?.userPublicProfile?.publicUrl)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: 
                          data.userPublicProfile.publicUrl ||
                          '../../../assets/images/avatar-info-image.png'
                        ,
                                          class: "tw-w-full tw-h-full tw-object-cover"
                                        }, null, 8, _hoisted_14))
                                      : (_openBlock(), _createBlock(_component_UserProfileLogo, {
                                          key: 1,
                                          isRounded: false,
                                          userName: `${data?.firstName} ${data?.lastName}`
                                        }, null, 8, ["userName"]))
                                  ], 2))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      ($setup.getUserWorkStationFieldAccess)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            (!$setup.isUserProprtyOwner)
                              ? (_openBlock(), _createBlock(_component_BlueCircularPencilIcon, {
                                  key: 0,
                                  class: "md:!tw-min-w-[21px] md:!tw-w-[21px] md:!tw-h-[21px]",
                                  onClick: ($event: any) => ($setup.editCertificate(certificate))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (!$setup.isUserProprtyOwner)
                              ? (_openBlock(), _createBlock(_component_GrayCircularTrashIcon, {
                                  key: 1,
                                  class: "md:!tw-min-w-[21px] md:!tw-w-[21px] md:!tw-h-[21px]",
                                  onClick: ($event: any) => ($setup.onDeleteItem(certificate))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!$setup.isLoading && !$setup.userCertificates?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("img", {
                src: require('../../../assets/images/trade-certificate-empty.png'),
                alt: "",
                class: "tw-w-full"
              }, null, 8, _hoisted_19)
            ]),
            (!$setup.isUserProprtyOwner)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_27)),
            _createElementVNode("div", _hoisted_28, [
              ($setup.getUserWorkStationFieldAccess && !$setup.isUserProprtyOwner)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    onClick: $setup.onClickAddNewCertification,
                    class: "button button-purple",
                    width: "100%"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("add new Certification")
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.isShowCertificateModal)
      ? (_openBlock(), _createBlock(_component_AddCertificateModal, {
          key: 3,
          onOnClickCloseTab: $setup.onClickCloseModel,
          userCertificateData: $setup.userCertificateData,
          onClearUserCertificateData: $setup.clearData
        }, null, 8, ["onOnClickCloseTab", "userCertificateData", "onClearUserCertificateData"]))
      : _createCommentVNode("", true),
    ($setup.isEditCertificateModal)
      ? (_openBlock(), _createBlock(_component_CertificateEditModal, {
          key: 4,
          onOnSaveData: $setup.onClickUpdateModal,
          onOnClickCloseTab: $setup.onClickCloseEditModal,
          userCertificateData: $setup.userCertificateData
        }, null, 8, ["onOnSaveData", "onOnClickCloseTab", "userCertificateData"]))
      : _createCommentVNode("", true),
    ($setup.isOpenConfirmDelete)
      ? (_openBlock(), _createBlock(_component_ConfirmDeleteModal, {
          key: 5,
          type: $setup.confirmDeleteCertificate.name,
          label: "You're about to delete your certification.",
          onOnClose: $setup.onCloseConfirmDelete,
          onOnDelete: $setup.deleteItem,
          loading: $setup.deleteLoader
        }, null, 8, ["type", "onOnClose", "onOnDelete", "loading"]))
      : _createCommentVNode("", true),
    ($setup.isShowCoursePreviewModal)
      ? (_openBlock(), _createBlock(_component_IknowaCoursePreviewModal, {
          key: 6,
          onOnClickClosePreviewModalButton: $setup.onClickCloseCoursePreviewModal
        }, null, 8, ["onOnClickClosePreviewModalButton"]))
      : _createCommentVNode("", true)
  ], 64))
}